module.exports = __webpack_public_path__ + "static/media/bgContacto.263dbba5.jpg";